import { useState } from 'react'
import cx from 'classnames'

import Loader from 'common/components/loaders/Loader'

import type { BrazeCampaignDetail } from './api/api'

type Props = {
  detail: BrazeCampaignDetail | undefined
  isLoading: boolean
}

const CampaignDetail = ({ detail, isLoading }: Props) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0)

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <Loader />
      </div>
    )
  }

  if (!detail) {
    return null
  }

  const messages = detail.messages.filter((msg) => !!msg.subject && !!msg.body)

  return (
    <div className="flex flex-col gap-4 pl-6 border-l border-gold-400">
      <div className="flex items-center gap-2">
        {detail.channels.map((channel) => (
          <span
            key={channel}
            className="px-2 py-0.5 text-xs font-medium rounded-full bg-maroon-40 text-maroon-500 border border-maroon-400 capitalize"
          >
            {channel}
          </span>
        ))}
      </div>

      <div className="flex flex-col gap-3">
        {messages.map((message, index) => {
          const isExpanded = expandedIndex === index
          const hasBody = !!message.body

          return (
            <div
              key={index}
              className="flex flex-col rounded border border-gold-400 bg-white overflow-hidden"
            >
              <div
                className={cx(
                  'flex items-center justify-between py-3 px-4',
                  hasBody && 'cursor-pointer hover:bg-gold-40'
                )}
                onClick={() =>
                  hasBody && setExpandedIndex(isExpanded ? null : index)
                }
              >
                <span className="text-sm text-base-700 flex-1 mr-4">
                  {message.subject}
                </span>
                <div className="flex items-center gap-3 shrink-0">
                  <span className="text-xs text-base-500 capitalize">
                    {message.channel}
                  </span>
                  {hasBody && (
                    <span className="text-xs text-maroon-500">
                      {isExpanded ? '▲ Hide' : '▼ Preview'}
                    </span>
                  )}
                </div>
              </div>

              {hasBody && isExpanded && (
                <iframe
                  srcDoc={message.body}
                  className="w-full border-t border-gold-400"
                  style={{ height: 600 }}
                  sandbox=""
                  title={`Message ${index + 1} preview`}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CampaignDetail
